import { render } from "./ALLCOm.vue?vue&type=template&id=afaf0462&scoped=true"
import script from "./ALLCOm.vue?vue&type=script&lang=js"
export * from "./ALLCOm.vue?vue&type=script&lang=js"

import "./ALLCOm.vue?vue&type=style&index=0&id=afaf0462&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afaf0462"]])

export default __exports__